export class WalletManager {
    constructor() {
        this.address = null;
        this.isConnected = false;
        this.provider = null;
    }

    async checkConnection() {
        if (typeof window.opnet === 'undefined') {
            console.log('OP_NET Wallet not detected');
            return false;
        }

        this.provider = window.opnet;

        try {
            const accounts = await this.provider.getAccounts();
            
            if (accounts && accounts.length > 0) {
                this.address = accounts[0];
                this.isConnected = true;
                return true;
            }
        } catch (error) {
            console.log('Wallet not connected yet');
        }

        return false;
    }

    async connect() {
        if (typeof window.opnet === 'undefined') {
            throw new Error('OP_NET Wallet не встановлено. Будь ласка, встановіть розширення.');
        }

        this.provider = window.opnet;

        try {
            const result = await this.provider.requestAccounts();

            if (!result || result.length === 0) {
                throw new Error('Не вдалося отримати адресу');
            }

            this.address = result[0];
            this.isConnected = true;

            this.setupEventListeners();

            return this.address;
        } catch (error) {
            console.error('Помилка підключення гаманця:', error);
            throw new Error('Не вдалося підключити OP_NET Wallet. ' + (error.message || 'Перевірте, чи розширення активне.'));
        }
    }

    setupEventListeners() {
        if (this.provider && this.provider.on) {
            this.provider.on('accountChanged', (address) => {
                if (!address) {
                    this.disconnect();
                    window.location.reload();
                } else {
                    this.address = address;
                    window.location.reload();
                }
            });

            this.provider.on('disconnect', () => {
                this.disconnect();
                window.location.reload();
            });
        }
    }

    disconnect() {
        // Спробуємо відключити гаманець через OP_NET API
        if (this.provider && typeof this.provider.disconnect === 'function') {
            try {
                this.provider.disconnect();
                console.log('🔌 Гаманець відключено через OP_NET API');
            } catch (error) {
                console.warn('Не вдалося відключити гаманець через API:', error);
            }
        }
        
        // Очищуємо локальні дані
        this.address = null;
        this.isConnected = false;
        this.provider = null;
        
        console.log('🔌 Локальні дані гаманця очищені');
    }

    getAddress() {
        return this.address;
    }

    isWalletConnected() {
        return this.isConnected;
    }

    formatAddress(address) {
        if (!address) return '';
        return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    }

    async getPublicKey() {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            return await this.provider.getPublicKey();
        } catch (error) {
            console.error('Failed to get public key:', error);
            throw error;
        }
    }

    async signMessage(message) {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            return await this.provider.signMessage(message);
        } catch (error) {
            console.error('Failed to sign message:', error);
            throw error;
        }
    }

    async sendBitcoin(toAddress, amount) {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            const txid = await this.provider.sendBitcoin(toAddress, amount);
            return txid;
        } catch (error) {
            console.error('Failed to send Bitcoin:', error);
            throw error;
        }
    }

    async signPsbt(psbtHex) {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            return await this.provider.signPsbt(psbtHex);
        } catch (error) {
            console.error('Failed to sign PSBT:', error);
            throw error;
        }
    }

    async pushPsbt(psbtHex) {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            return await this.provider.pushPsbt(psbtHex);
        } catch (error) {
            console.error('Failed to push PSBT:', error);
            throw error;
        }
    }

    async callContract(contractAddress, method, params = []) {
        if (!this.provider) {
            throw new Error('Wallet not connected');
        }
        try {
            // Спроба викликати метод контракту через OP_NET API
            if (typeof this.provider.callContract === 'function') {
                return await this.provider.callContract(contractAddress, method, params);
            }
            
            // Альтернативний метод через sendBitcoin з даними
            if (typeof this.provider.sendToContract === 'function') {
                return await this.provider.sendToContract(contractAddress, method, params);
            }

            // Якщо немає спеціальних методів, використовуємо sendBitcoin
            console.warn('Contract call methods not available, using sendBitcoin as fallback');
            return await this.provider.sendBitcoin(contractAddress, 546);
        } catch (error) {
            console.error('Failed to call contract:', error);
            throw error;
        }
    }
}
